module.exports = __webpack_public_path__ + "img/mpjh.ba341d69.png";